module.exports = __webpack_public_path__ + "static/media/burger-logo.b8503d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/burger-logo.png
// module id = 67
// module chunks = 0